import React, { useState, useContext } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { MapContext } from '../MapContext';
import { CatalogContext } from '../CatalogContext';
import AddGeneButton from '../Gene/AddGeneButton';

export const GeneGrid = ({ tableData }) => {
  
  const { map }  = useContext(MapContext);
  const { catalog } = useContext(CatalogContext);

  const tableTheme = createTheme({
    palette: {
      secondary: {
        main: '#AAA'
      },
      primary: {
        main: '#DDD'
      },
      mode: 'dark',
    },
    typography: {
      fontSize: 12
    }, 
  });
  const renderViewButton = (params) => {
    const genePMTilesLocation = catalog?.assets.sge.perGene;
    return (
      genePMTilesLocation ?
      <AddGeneButton
        row={params.row}
        map={map}
        gene_field='gene_name'
        genePMTilesLocation={genePMTilesLocation}
        catalogId={catalog.id}
      />
      : null
    )
  }

  const columns_main = [
    { field: 'gene_name', headerName: 'Gene', flex: 1.4, 
      renderCell: renderViewButton, 
      disableClickEventBubbling: true},
    { field: 'targetCount', headerName: 'Target Cnt', flex: 1, 
      type: 'number', disableClickEventBubbling: true, },
    {
      field: 'targetFreq', headerName: 'Target Freq',
      flex: 1, type: 'number', disableClickEventBubbling: true,
      valueFormatter: ({ value }) => value.toExponential(3),
      hide: true
    },
    { field: 'targetTotal', headerName: 'Target Total', flex: 1, 
      type: 'number', disableClickEventBubbling: true, hide: true },

    { field: 'OR', headerName: 'OR', flex: 1.2, type: 'number', 
      disableClickEventBubbling: true },
    { field: 'pvalue', headerName: 'p-value', flex: 1.2, 
      valueFormatter: ({ value }) => value.toExponential(3),
      type: 'number', disableClickEventBubbling: true },
    { field: 'comparisonCount', headerName: 'Comp. Cnt', flex: 1, 
      type: 'number', disableClickEventBubbling: true },
    {
      field: 'comparisonFreq', headerName: 'Comp. Freq',
      flex: 1, type: 'number', disableClickEventBubbling: true,
      valueFormatter: ({ value }) => value.toExponential(3),
      hide: true
    },
    { field: 'comparisonTotal', headerName: 'Comp. Total', flex: 1, 
      type: 'number', disableClickEventBubbling: true, hide: true },
  ];
  
  return (
    <ThemeProvider theme={tableTheme}>
    <DataGrid
      initialState={{
        pagination: { paginationModel: { pageSize: 50 } },
        columns: {
          columnVisibilityModel: {
            targetFreq: false,
            targetTotal: false,
            comparisonFreq: false,
            comparisonTotal: false
          },
        },
      }}
      disableRowSelectionOnClick
      rows={tableData}
      columns={columns_main}
      rowHeight={30}
      hideFooter={false}
      // autoHeight={true}
      density='compact'
      components={{
        Toolbar: GridToolbar,
      }}
    />
    </ThemeProvider>
  )
}

export default GeneGrid;
